import { useCoreApi } from "providers/CoreApiProvider";
import React from "react";
import { BasePublicationSelectorDrawer, PublicationSelectorFilterOptions, PublicationSelectorProps } from "views/knowledge/publication/drawers/BasePublicationSelectorDrawer";

////////////////////////////////////////////////////////////////////////////////

export const PublicationSelectorShortVideoDrawer: React.FC<PublicationSelectorProps> = (props) => {
    const api = useCoreApi();

    const handleGetdata = ({ signal, ...filter }: PublicationSelectorFilterOptions) => {
        return api.v1.knowledgeShortVideo.publicationSelector({
            ...filter,
        }, { signal: signal });
    };

    return <BasePublicationSelectorDrawer
        onGetData={handleGetdata}
        {...props}
    />;
};
